<div class="cd-page">
  <!-- SIDEBAR -->
  <app-district-nav></app-district-nav>

  <!-- MAIN -->
  <main class="cd-main" aria-label="District Admin dashboard">
    <div>
      <h1 class="cd-title">Dashboard</h1>
      <p class="cd-subtitle">{{ today }}</p>
    </div>

    <div class="cd-stats" role="list" aria-label="Dashboard statistics">
      <div class="cd-stat" role="listitem" [attr.aria-label]="totalSchools() + ' total schools'">
        <div class="cd-stat-num" aria-hidden="true">{{ totalSchools() }}</div>
        <div class="cd-stat-label" aria-hidden="true">Total Schools</div>
      </div>
    </div>

    <!-- District Schools -->
    <div class="cd-card">
      <div class="cd-card-header">
        <h2>District Schools</h2>
      </div>

      <div role="list" aria-label="School roster">
        @for (s of schools(); track s.id) {
          <div class="cd-student-row" role="listitem">
            <button
              type="button"
              class="cd-student-button"
              [attr.aria-label]="'View staff for ' + s.name"
              [attr.data-testid]="'school-button-' + s.id"
              (click)="openStaffDialog(s)"
            >
              <div class="cd-student-name">
                {{ s.name }}
              </div>
            </button>
          </div>
        }
      </div>
    </div>
  </main>
</div>
